import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiGlobe, FiType, FiDroplet, FiCircle, FiVideoOff, FiClock } from 'react-icons/fi';
import './Personalization.css';

function Personalization() {
  const { t } = useTranslation();
  
  const benefits = [
    {
      icon: <FiGlobe />,
      titleKey: 'personalization.url.title',
      descriptionKey: 'personalization.url.description'
    },
    {
      icon: <FiType />,
      titleKey: 'personalization.subtitles.title',
      descriptionKey: 'personalization.subtitles.description'
    },
    {
      icon: <FiDroplet />,
      titleKey: 'personalization.branding.title',
      descriptionKey: 'personalization.branding.description'
    },
    {
      icon: <FiCircle />,
      titleKey: 'personalization.recording.title',
      descriptionKey: 'personalization.recording.description'
    },
    {
      icon: <FiVideoOff />,
      titleKey: 'personalization.broadcast.title',
      descriptionKey: 'personalization.broadcast.description'
    },
    {
      icon: <FiClock />,
      titleKey: 'personalization.unlimited.title',
      descriptionKey: 'personalization.unlimited.description'
    }
  ];

  return (
    <section id="personnalisation" className="personalization section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('personalization.title')}</h2>
          <p className="section-quick-answer">{t('personalization.quickAnswer')}</p>
          <p className="section-subtitle">
            {t('personalization.subtitle')}
          </p>
        </div>

        <div className="personalization-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="personalization-card">
              <div className="personalization-icon">
                {benefit.icon}
              </div>
              <h3 className="personalization-title">{t(benefit.titleKey)}</h3>
              <p className="personalization-description">{t(benefit.descriptionKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Personalization;

